import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../../layout/dashboard/DashboardLayout";
import TitleTextBox from "../../../../fragments/TitleTextBox";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../../redux/types";
import { lowerCaseWrap } from "../../../../helper";
import Icons from "../../../../assets/icons/icons";
import "../../../../styles/dashboard/terminals/viewRequestedTerminalGridIndex.css";
import RequestedTerminalDetails from "./requestedTerminalDetails";
import {
  getMerchantTerminalRequest,
  getSingleRequestDetail,
} from "../../../../redux/insight";
import { RavenBadge, RavenNumberFormat } from "@ravenpay/raven-bank-ui";
import { formatCustomDate, formatDateTwo } from "../../../../utils/helpers";
import BadgeComponent from "../../../../fragments/badge/BadgeComponent";
import AllMerchantTerminals from "../AllMerchantTerminals";
import NoContentPage from "../../../../fragments/NoContentPage";

const ViewRequestedTerminal = () => {
  const dispatch = useDispatch();
  const {
    loading_reciept,
    all_device_request,
    all_virtual_terminals,
    insight_terminals,
  } = useSelector((state: RootState) => state.insights);
  const [singleObject, setSingleObject] = useState({});
  const [visible, setVisible] = useState(false);
  const [terminalId, setTerminalId] = useState(0);

  const handleGetRequests = async () => {
    const obj = {
      name: "",
    };

    const data = await dispatch(getMerchantTerminalRequest(obj as any) as any);

    if (data?.payload?.status === "success") {
      // console.log(data);
    } else {
      // console.error("Request failed:", data);
    }
  };
  useEffect(() => {
    handleGetRequests();
  }, []);

  const [singleDetail, setSingleDetail] = useState({
    quantity: 0,
    status: "",
    deliveryType: "",
    contact: "",
    dateRequested: "",
    email: "",
    address: "",
  });

  const handleGetDetail = async (id: number) => {
    const obj = {
      id: id,
    };
    const data = await dispatch(getSingleRequestDetail(obj as any) as any);

    if (data) {
      // console.log(data, "da--------");
    } else {
      // console.error("Request failed:", data);
    }
  };
  return (
    <>
      <AllMerchantTerminals
        loading={loading_reciept}
        noContent={
          Object?.keys(all_virtual_terminals)?.length < 1 &&
          Object?.keys(insight_terminals)?.length < 1 &&
          Object?.keys(all_device_request)?.length < 1
        }
      >
        <div
          onClick={() => {
            console.log(all_device_request);
          }}
          className="view-requested-terminal-wrap"
        >
          { Object?.keys(all_device_request)?.length < 1 ? (
            <>
              <NoContentPage
                styles={{
                  height: "calc(100vh - 40rem)",
                  border: "unset",
                  boxShadow: "unset",
                  padding: "unset",
                }}
                loading={loading_reciept}
              />
            </>
          ) : (
            <div
              className="view-requested-terminal"
              style={{
                justifyContent:
                  Object?.keys(all_device_request)?.length > 0 &&
                  all_device_request?.data.length < 4
                    ? "flex-start"
                    : "space-between",
                display:
                  Object?.keys(all_device_request)?.length > 0 &&
                  all_device_request?.data.length < 4
                    ? "flex"
                    : "grid",
              }}
            >
              {all_device_request?.data?.map((chi: any, idx: any) => {
                const { quantity, amount, phone, status, created_at, id } =
                  chi || {};
                return (
                  <div
                    onClick={() => {
                      setSingleObject(chi);
                      setVisible(true);
                      // console.log(chi);
                    }}
                    className="request-view-grid-box grey-bg"
                    style={{
                      minWidth: "32rem",
                    }}
                  >
                    {/* top box starts here */}
                    <div className="request-top-box-holder">
                      {loading_reciept ? (
                        <Skeleton
                          width={70}
                          height={17}
                          style={{ marginBottom: ".3rem" }}
                        />
                      ) : (
                        <p className="number-of-items">
                          {quantity}
                          <span> pcs</span>
                        </p>
                      )}
                      {loading_reciept ? (
                        <Skeleton
                          width={70}
                          height={17}
                          style={{ marginBottom: ".3rem" }}
                        />
                      ) : (
                        <p className="amount">
                          Amount: <span> {RavenNumberFormat(amount)}</span>
                        </p>
                      )}
                    </div>
                    {/* top box ends here */}
                    <div className="card-bg bottom-box-wrap">
                      {loading_reciept ? (
                        <Skeleton width={100} height={22} />
                      ) : (
                        <div className="bottom-box-inner">
                          <div className="bottom-value-inner-top">
                            <div className="top-inner">
                              <div className="img-terminal">
                                <figure className="img-box ">
                                  {Icons.ring}
                                </figure>
                              </div>
                              <p className="phone-number">
                                Phone No.
                                <span> {phone}</span>
                              </p>
                            </div>
                            {/* <div className="img-terminal">
                          <figure className="img-box">{Icons.threeDot}</figure>
                        </div> */}
                          </div>
                          <div className="bottom-value-inner-bottom">
                            <RavenBadge
                              text={
                                status === 0 || status === 1
                                  ? "● Pending"
                                  : status === 3
                                  ? "● Approved"
                                  : status === 4
                                  ? "● Delivered"
                                  : ""
                              }
                              type={
                                status === 0 || status === 1
                                  ? "yellow"
                                  : status === 3
                                  ? "green"
                                  : status === 4
                                  ? "info"
                                  : ""
                              }
                            />

                            <p className="requested-on">
                              Requested on :{" "}
                              <span>{formatCustomDate(created_at)}</span>
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </AllMerchantTerminals>

      {/* modal start here ------ */}
      <RequestedTerminalDetails
        id={terminalId}
        visible={visible}
        onClose={() => setVisible(false)}
        details={singleObject}
        // onClick={() => setVisible(false)}
      />
    </>
  );
};

export default ViewRequestedTerminal;
